/**
 * @type interface
 */
export interface IStoreState {
	token: string;
	user: any;
}

/**
 * @class State
 * @package Store/Module/Authentication
 * @project ChalkySticks App
 */
const state: IStoreState = {
	token: '',
	user: undefined,
};

export default state;
